<template>
  <div>
    <div
      v-if="data.updateDate !== null"
      class="grid-cell"
    >
      <span class="grid-cell--subtitle">{{ data.updateDate }} ({{ timezoneEnv }}) </span> <br>
      <span class="grid-cell--subtitle">{{ data.updatedBy }}</span>
    </div>
    <div
      v-if="data.updateDate === null"
      class="grid-cell"
    >
      <span>N/A</span>
    </div>
  </div>
</template>

<script>
import { systemTimezone } from '../../constants/general'
export default {

  data () {
    return {
      timezoneEnv: ''
    }
  },
  mounted () {
    this.timezoneEnv = systemTimezone()
  }
}
</script>

<style lang="scss" scoped>
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
.grid-cell--subtitle {
  color: #666;
}
</style>
